export default __webpack_public_path__ + "static/media/signup-img-2.80305c0b.png";